// extracted by mini-css-extract-plugin
module.exports = {"root":"hand-sanitizer-disposal-page_root__i0o5f"};